import { IMeta, IMetaNew, INameObject, INameObjectIdN, INameObjectIdNApi } from './index';

export enum PackageType {
    LOCAL = 'local',
    ROAMING = 'roaming',
    EXTRA = 'extra',
    POOL = 'pool',
}

type NetworkWithCountry = INameObjectIdNApi & {
    country?: INameObjectIdNApi;
};

export interface ITariffApi {
    tariff: ITariffApiItem;
}

export interface ITariffsApi {
    tariffs: ITariffApiItem[];
    meta: IMeta;
}

export type ITariffCardItem = {
    card_id: string;
    card_name: string;
};

export interface ITariffApiItem {
    id: string;
    name: string;
    description: string;
    price_cents: number;
    company_id: string;
    out_of_bundle: boolean;
    product_id?: string;
    plan_type?: string;
    assigned_companies_count: number;
    roaming_packages_count: number;
    cards_count: number;
    created_at: string;
    company: { id: number; name: string };
    networks: Array<{ id: number; name: string }>;
    operators: Array<{ id: number; name: string }>;
    countries: Array<{ id: number; name: string }>;
    tariff_packages: any;
    tariff_package_instances: ITariffCardItem[];
}

export type ITariffsList = ITariff[];
export interface ITariff {
    id: string;
    name: string;
    description: string;
    assignedCompaniesCount: number;
    cards?: ITariffCardItem[];
    cardsCount: number;
    companies?: { id: string; name: string }[];
    companyId: { id: string; name: string };
    companyName: string;
    createdAt: string;
    outOfBundle: boolean;
    planType?: string;
    price?: number;
    priceCents?: number;
    productId?: string;
    roamingPackagesCount: number;
    tariffPackages: IPackage[];
}

export interface IPostTariffApi {
    name: string;
    price_cents: number;
    out_of_bundle: boolean;
    product_id?: string;
    plan_type?: string;
    tariff_package_ids: number[];
    company_ids: number[];
}

export interface IPostTariff {
    name: string;
    companyId: string;
    companyIds: number[];
    description: string;
    initialTariffLocalPackagesIds?: number[];
    initialTariffRoamingPackagesIds?: number[];
    outOfBundle: boolean;
    planType?: string;
    priceCents?: number;
    productId?: string;
    tariffPackageIds: number[];
    tariffLocalPackagesIds?: number[];
    tariffRoamingPackagesIds?: number[];
    tariffPackages?: IPackage[];
}

export type IProcessPatchTariff = {
    initialTariffLocalPackagesIds?: number[];
    initialTariffRoamingPackagesIds?: number[];
    tariffLocalPackagesIds?: number[];
    tariffRoamingPackagesIds?: number[];
    tariffPackages?: IPackage[];
    patchData: IPostTariff;
};

export interface IPackageApi {
    tariff_packages: IPackageApiItem[];
    meta: IMeta;
}

export interface IPackageApiItem {
    id: number;
    name?: string;
    data_volume?: number;
    data_volume_unit?: string;
    sms_volume?: number;
    voice_volume?: number;
    package_type?: string;
    price_cents?: number;
    product_id?: string;
    plan_type?: string;
    tariffs_count?: number;
    renewable?: boolean;
    company?: INameObjectIdNApi;
    networks?: Array<
        INameObjectIdNApi & {
            country?: INameObjectIdNApi;
        }
    >;
    operators?: Array<INameObjectIdNApi>;
    countries?: Array<INameObjectIdNApi>;
}

export interface IPostPackageApi {
    tariff_package: IPackageApiItem;
}

export type IPackagesList = IPackage[];

export type IPackageListPaginated = {
    data: IPackagesList;
    meta: IMeta;
};

export interface IPackage {
    id: string;
    name?: string;
    card?: INameObject;
    cardId?: string;
    cardsCount?: number;
    company?: INameObjectIdNApi;
    companyId?: string;
    companyIds?: number[];
    companyName?: string;
    createdAt?: string;
    dataVolume?: number;
    dataVolumeUnit?: string;
    endDate?: string;
    nonExpirable?: boolean;
    outOfBundle?: boolean;
    packageType?: PackageType;
    planType?: string;
    price?: number;
    priceCents?: number;
    productId?: string;
    renewable?: boolean;
    smsVolume?: number;
    startDate?: string;
    tariffs?: ITariff[];
    tariffsCount?: number;
    tariffTariffPackageId?: number;
    voiceVolume?: number;
    networks?: Array<NetworkWithCountry>;
    operators?: Array<INameObjectIdNApi>;
    countries?: Array<INameObjectIdNApi>;
    companies?: Array<INameObjectIdNApi>;
}

export interface IPostPackage {
    companyId: number;
    companyIds?: number[];
    countryIds?: number[];
    dataVolume: number;
    dataVolumeUnit: string;
    name: string;
    networkIds: number[];
    operatorIds: number[];
    packageType: PackageType;
    planType?: string;
    priceCents: number;
    productId?: string;
    smsVolume: number;
    voiceVolume: number;
}

export interface IPostAssignPackage {
    tariffId: string;
    tariffPackageId: string;
}

//-------------

export type IRequestTariffPackageInstanceItemAPI = {
    id: number;
    card: null;
    card_set?: INameObjectIdN;
    company?: INameObjectIdN;
    created_at?: string;
    data_volume?: number;
    data_volume_percentage_usage?: number;
    data_volume_unit?: string;
    end_date?: string;
    non_expirable?: boolean;
    out_of_bundle?: boolean;
    package_type?: string;
    renewable: false;
    sms_volume?: number;
    sms_volume_percentage_usage?: number;
    start_date?: string;
    voice_volume?: number;
    voice_volume_percentage_usage?: number;
    tariff_package: {
        id: number;
        name?: string;
        data_volume?: number;
        data_volume_unit?: string;
        sms_volume?: number;
        voice_volume?: number;
        operators?: INameObjectIdN[];
        operator2s?: INameObjectIdN[];
        networks?: ITariffPackageInstanceTariffPackageNetwork[];
        package_type?: string;
        renewable?: boolean;
    };
};

export type ITariffPackageInstanceTariffPackageNetwork = INameObjectIdN & {
    country?: INameObjectIdN;
};

export type ITariffPackageInstanceCardItem = {
    id: number;
    iccid?: string;
    msisdn?: string;
    name?: string;
    usageLimitByte?: number;
    usageLimitInUnit?: number;
    usageLimitUnit?: string;
    usedAmount?: number;
};
export type ITariffPackageInstanceCardItemAPI = {
    id: number;
    iccid?: string;
    msisdn?: string;
    name?: string;
    new_usage_limit?: number;
    usage_limit?: number;
    usage_limit_unit?: string;
    used_amount?: number;
};
export interface ITariffPackageInstanceCardAPI {
    cards: ITariffPackageInstanceCardItemAPI[];
    meta: IMeta;
}

export interface ITariffPackageInstance extends Omit<IPackage, 'company'> {
    cardSet?: INameObjectIdNApi;
    company?: INameObjectIdNApi;
    dataVolumeAvailable: number;
    dataVolumePercentageUsage: number;
    dataVolumeTotal: number;
    smsVolumeAvailable: number;
    smsVolumePercentageUsage: number;
    smsVolumeTotal: number;
    voiceVolumeAvailable: number;
    voiceVolumePercentageUsage: number;
    voiceVolumeTotal: number;
    tariffPackage: IPackage;
}

export interface ITariffPackageInstanceApi {
    tariff_package_instances: ITariffPackageInstanceApiItem[];
    meta: IMeta;
}

export interface ITariffPackageInstanceApiItem extends IPackageApiItem {
    card?: INameObjectIdNApi;
    card_set?: INameObjectIdNApi;
    created_at?: string;
    data_volume_percentage_usage?: number;
    end_date?: string;
    non_expirable?: boolean;
    out_of_bundle?: boolean;
    sms_volume_percentage_usage?: number;
    start_date?: string;
    voice_volume_percentage_usage?: number;
    tariff_package: IPackageApiItem;
}

export interface ITariffPackageInstanceStatisticItem {
    cardId?: number;
    name?: string;
    volume?: number;
}

//--------------

export interface ITariffStatistics {
    roaming: number;
    local: number;
    extra: number;
}

// ------------ TariffToBuy ------------

export type ITariffToBuyListApi = {
    tariffs: ITariffToBuyListItemApi[];
    meta: IMetaNew;
};
export type ITariffToBuyListItemApi = INameObjectIdN & {
    assigned_companies_count?: number;
    cards_count?: number;
    companies?: INameObjectIdN[];
    company?: INameObjectIdN;
    company_id?: number;
    created_at?: string;
    description?: string;
    out_of_bundle?: boolean;
    plan_type?: string;
    price_cents?: number;
    product_id?: string;
    roaming_packages_count?: number;
    tariff_packages?: INameObjectIdN[];
};

export type ITariffToBuyItemApi = Omit<ITariffToBuyListItemApi, 'tariff_packages'> & {
    tariff_packages?: ITariffToBuyItemPackagesItemApi[];
    cards?: INameObjectIdN[];
};
export type ITariffToBuyItemPackagesItemApi = INameObjectIdN & {
    data_volume?: number;
    sms_volume?: number;
    voice_volume?: number;
    package_type?: string;
    price_cents?: number | null;
    product_id?: string;
    plan_type?: string | null;
    operators: INameObjectIdN[];
    networks: INameObjectIdN[];
};

export type ITariffToBuyListItem = ITariff;

export type ITariffToBuyListPaginated = {
    list: ITariffToBuyListItem[];
    meta: IMeta;
};

export type ITariffToBuyItemResponseApi = {
    tariff?: ITariffToBuyItemApi;
};

export type ITariffToBuyItem = ITariffToBuyListItem & {
    tariffPackages?: ITariffToBuyItemPackagesItem[];
    cards?: INameObjectIdN[];
};

export type ITariffToBuyItemPackagesItem = INameObjectIdN & {
    dataVolume?: number;
    dataVolumeUnit?: string;
    smsVolume?: number;
    voiceVolume?: number;
    packageType?: PackageType;
    price?: number | null;
    priceCents?: number | null;
    productId?: string;
    planType?: string | null | undefined;
    operators?: INameObjectIdN[];
    networks?: INameObjectIdN[];
};
// ------------ TariffPackagesToBuy ------------

export type ITariffPackagesToBuyListApi = {
    tariff_packages: ITariffPackagesToBuyListItemApi[];
    meta: IMetaNew;
};

export type ITariffPackagesToBuyListItemApi = ITariffToBuyListItemApi & {
    data_volume?: number;
    sms_volume?: number;
    voice_volume?: number;
    package_type?: string;
    tariffs_count?: number;
    networks?: ITariffPackagesToBuyListItemNetworks[];
    operators?: INameObjectIdN[];
};
export type ITariffPackagesToBuyListItemNetworks = INameObjectIdN & {
    country: INameObjectIdN;
};

export type ITariffPackagesToBuyListItem = Omit<ITariffToBuyItemPackagesItem, 'networks, company'> & {
    cardsCount?: number;
    assignedCompaniesCount?: number;
    tariffsCount?: number;
    companyId?: INameObjectIdN;
    networks?: ITariffPackagesToBuyListItemNetworks[];
    company?: INameObject;
};

export type ITariffPackagesToBuyListPaginated = {
    data: ITariffPackagesToBuyListItem[];
    meta: IMeta;
};

export type ITariffPackagesToBuyItemRequestApi = {
    tariff_package: ITariffPackagesToBuyItemApi;
};

export type ITariffPackagesToBuyItemApi = ITariffPackagesToBuyListItemApi & {
    company_ids?: number[];
    tariffs?: number[];
};

export type ITariffPackagesToBuyItem = IPackage;
